(function () {
  if (window.WoodarqSharedGallery && window.WoodarqSharedGallery.initAll) {
    window.WoodarqSharedGallery.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-woodarq-shared-gallery]';
  var TEXT_SELECTOR = '[data-shared-text-reveal]';
  var ITEM_SELECTOR = '[data-shared-item]';
  var LOAD_MORE_SELECTOR = '[data-shared-load-more]';
  var ACTIONS_SELECTOR = '[data-shared-actions]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function refreshScrollSystems() {
    window.dispatchEvent(new Event('resize'));

    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      window.ScrollTrigger.refresh();
    }
  }

  function splitChars(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.textContent = '';

    for (var i = 0; i < text.length; i += 1) {
      var span = document.createElement('span');
      span.className = 'wa-shared-char';
      span.style.setProperty('--wa-shared-split-index', i);
      span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
      el.appendChild(span);
    }
  }

  function splitWords(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    var words = text.split(' ');
    el.textContent = '';

    words.forEach(function (word, index) {
      var span = document.createElement('span');
      span.className = 'wa-shared-word';
      span.style.setProperty('--wa-shared-split-index', index);
      span.textContent = word;
      el.appendChild(span);

      if (index < words.length - 1) {
        el.appendChild(document.createTextNode(' '));
      }
    });
  }

  function prepareText(root) {
    if (prefersReducedMotion()) return;

    toArray(root.querySelectorAll(TEXT_SELECTOR)).forEach(function (el) {
      if (el.__waSharedSplitReady) return;
      el.__waSharedSplitReady = true;

      var splitType = el.getAttribute('data-shared-split');
      if (splitType === 'chars') splitChars(el);
      if (splitType === 'words') splitWords(el);
    });
  }

  function setItemDelays(root) {
    toArray(root.querySelectorAll(ITEM_SELECTOR + ':not([hidden])')).forEach(function (item, index) {
      item.style.setProperty('--wa-shared-item-delay', Math.min(index * 95, 475) + 'ms');
    });
  }

  function revealItem(item) {
    if (!item) return;
    item.classList.add('is-shared-visible');
  }

  function setupVisibility(root) {
    if (!root || root.__waSharedObserverBound) return;
    root.__waSharedObserverBound = true;

    setItemDelays(root);

    var visibleItems = function () {
      return toArray(root.querySelectorAll(ITEM_SELECTOR + ':not([hidden])'));
    };

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.add('is-shared-ready');
      visibleItems().forEach(revealItem);
      return;
    }

    var rootObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-shared-ready');
        rootObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -10% 0px'
    });

    rootObserver.observe(root);

    var itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealItem(entry.target);
        itemObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -8% 0px'
    });

    root.__waSharedItemObserver = itemObserver;
    visibleItems().forEach(function (item) {
      itemObserver.observe(item);
    });
  }

  function getHiddenItems(root) {
    return toArray(root.querySelectorAll(ITEM_SELECTOR + '[hidden]'));
  }

  function updateLoadMoreState(root) {
    var actions = root.querySelector(ACTIONS_SELECTOR);
    var button = root.querySelector(LOAD_MORE_SELECTOR);
    var hiddenItems = getHiddenItems(root);

    if (!button || !actions) return;

    if (!hiddenItems.length) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      actions.classList.add('is-hidden');
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-disabled');
    actions.classList.remove('is-hidden');
  }

  function revealNextItems(root) {
    var loadIncrement = parseInt(root.getAttribute('data-load-increment'), 10) || 6;
    var hiddenItems = getHiddenItems(root);
    var nextItems = hiddenItems.slice(0, loadIncrement);

    nextItems.forEach(function (item) {
      item.hidden = false;
      item.classList.remove('is-hidden-until-load');
      item.classList.remove('is-shared-visible');
    });

    setItemDelays(root);

    nextItems.forEach(function (item, index) {
      item.style.setProperty('--wa-shared-item-delay', Math.min(index * 95, 475) + 'ms');

      if (root.__waSharedItemObserver && !prefersReducedMotion()) {
        root.__waSharedItemObserver.observe(item);
      } else {
        window.setTimeout(function () {
          revealItem(item);
        }, 40 + index * 95);
      }

      if (root.classList.contains('is-shared-ready')) {
        window.setTimeout(function () {
          revealItem(item);
        }, 40 + index * 95);
      }
    });

    updateLoadMoreState(root);
    refreshScrollSystems();
  }

  function setupLoadMore(root) {
    var button = root.querySelector(LOAD_MORE_SELECTOR);
    if (!button || button.__waSharedLoadMoreBound) return;

    button.__waSharedLoadMoreBound = true;
    button.addEventListener('click', function () {
      revealNextItems(root);
    });

    updateLoadMoreState(root);
  }

  function initRoot(root) {
    if (!root) return;
    prepareText(root);
    setupVisibility(root);
    setupLoadMore(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    toArray(container.querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
  }

  window.WoodarqSharedGallery = {
    initAll: initAll,
    initRoot: initRoot
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  window.addEventListener('load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  initAll();
})();
